module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"buttons":{"getDependantVisa":"Start dependant visa"}}}')
  delete Component.options._Ctor
}
